export default __webpack_public_path__ + "503aca7944f3e9cf235de6d941c05f5c.png";